"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterContainer = exports.HeaderContainer = exports.ContentContainer = void 0;

var tslib_1 = require("tslib");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var withSeparatorStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  box-shadow: inset 0 0.0625rem 0\n    ", ";\n"], ["\n  box-shadow: inset 0 0.0625rem 0\n    ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY[\"200\"]", theme);
});
exports.ContentContainer = (0, styled_components_1.default)(ui_flex_1.Flex).attrs({
  flexDirection: 'column'
})(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  max-height: 100vh;\n"], ["\n  max-height: 100vh;\n"])));
exports.HeaderContainer = (0, styled_components_1.default)(ui_flex_1.Flex).attrs({
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column'
})(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject([""], [""])));
exports.FooterContainer = (0, styled_components_1.default)(ui_flex_1.Flex).attrs({
  justifyContent: 'center',
  flexDirection: 'column'
})(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'withSeparator', withSeparatorStyles);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;